import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import {apiUrl} from "../../../../apiUrl";

export const AutoGrading = () => {
    const {state} = useLocation()
    const navigate = useNavigate()
    const autoGrade = window.confirm('자동채점하시겠습니까?')
    if (autoGrade) {
        axios.get(`${apiUrl}/autoGrade?id=${state.appId}`)
            .then(res => {
                alert(res.data)
                navigate(-1)
            })
    }
    else {
        navigate(-1)
        alert('취소되었습니다.')
    }
}